import { inject, Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { StorageLogicService } from 'src/app/shared/utils/services/storage-logic.service';
import { appleConfig } from 'src/environments/apple-config';

declare const AppleID: any;

@Injectable({
  providedIn: 'root'
})
export class AppleAuthService {

  private readonly storageService = inject(StorageLogicService);

  public prepareSignInPayload(queryMap: ParamMap) {
    const idToken = queryMap.get('apple_token');
    const userData = queryMap.get('user');

    const parseUser = () => {
      if (!userData) {
        return {
          name: '',
          email: this.decodeJWT(idToken!).email,
        };
      }

      const { name, email } = JSON.parse(userData);

      return {
        name: `${name?.firstName ?? ''} ${name?.lastName ?? ''}`.trim(),
        email,
      };
    };

    const user = parseUser();

    return {
      city_id: this.storageService.getData('city'),
      name: user.name,
      email: user.email,
    };
  }

  private decodeJWT(token: string): { sub: string;  email:string} {
    const payload = token.split('.')[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  }

  public initAppleSignIn(sourcePath:'default'|'activate_promo'|'wheel', promo?:string|null): void {
    
    let state ='';

    switch(sourcePath){
      case 'wheel':
        state = encodeURIComponent(JSON.stringify({ tab: 'wheel_of_fortune', destination:'profile' }));
        break;
      case 'activate_promo':
        state = encodeURIComponent(JSON.stringify({c: promo, destination:'p'}));
        break;
      default:
        state='';
        break;
    }

    AppleID.auth.init({
      clientId: appleConfig.clientId,
      scope: 'name email',
      redirectURI: appleConfig.redirectURI,
      usePopup: false,
      responseType: 'code id_token',
      responseMode: 'form_post',
      state
    });

    AppleID.auth.signIn();
  }
}
